import React, { FC } from 'react'

import styled from 'styled-components'

import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { CTAButton } from 'src/Components/Buttons/CTAButton'

const ButtonsContainer = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  border-top: 1px solid #e7e7e7;
  background: #fff;
  display: flex;
  width: 100%;
  padding: 8px 16px;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
`

const StyledCTAButton = styled(CTAButton)`
  padding-left: 40px;
  padding-right: 40px;
`

type SpotifyGenresModalButtonsProps = {
  disabledAdd: boolean
  onClickAddGenres: () => void
  onClickGoBack: () => void
}

export const SpotifyGenresModalButtons: FC<SpotifyGenresModalButtonsProps> = (
  props,
) => {
  const { disabledAdd, onClickAddGenres, onClickGoBack } = props
  return (
    <ButtonsContainer>
      <PrimaryDottedButton onClick={onClickGoBack}>Go Back</PrimaryDottedButton>
      <StyledCTAButton onClick={onClickAddGenres} disabled={disabledAdd}>
        Add Genres
      </StyledCTAButton>
    </ButtonsContainer>
  )
}
